import { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { ArrowLeft, ArrowRight, Mail } from 'lucide-react';
import { LogoFull } from '../components/Logo';
import api from '../lib/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post('/auth/forgot-password', { email: email.trim().toLowerCase() });
      setSent(true);
    } catch {
      toast.error('No pudimos procesar la solicitud. Inténtelo de nuevo.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col p-8 lg:p-14">
      <div className="flex items-center">
        <LogoFull height={30} />
      </div>
      <div className="flex-1 flex items-center">
        <div className="w-full max-w-md mx-auto">
          <Link to="/login" className="inline-flex items-center gap-1 text-[13px] text-[#6B7280] hover:text-[#143A34]">
            <ArrowLeft size={13} /> Volver a inicio de sesión
          </Link>
          <h1 className="mt-4 text-3xl font-semibold text-[#1C2329] tracking-tight">Recuperar contraseña</h1>
          {sent ? (
            <div className="mt-6 p-5 border border-[#A7F3D0] bg-[#ECFDF5]" data-testid="forgot-sent">
              <div className="flex items-start gap-2">
                <Mail size={16} className="text-[#065F46] mt-0.5" />
                <div className="text-[14px] text-[#065F46]">
                  Si el correo <b>{email}</b> tiene una cuenta en Priviax, le enviamos un enlace
                  para restablecer la contraseña. Es válido por <b>1 hora</b>.
                </div>
              </div>
            </div>
          ) : (
            <>
              <p className="mt-3 text-[15px] text-[#6B7280] leading-relaxed">
                Le enviaremos un enlace de un solo uso para crear una nueva contraseña. El enlace vence en 1 hora.
              </p>
              <form onSubmit={onSubmit} className="mt-8 space-y-4" data-testid="forgot-form">
                <div>
                  <label className="block text-[12px] font-medium text-[#374151] mb-1.5 uppercase tracking-wider">Correo</label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="pv-input"
                    placeholder="nombre@empresa.cl"
                    autoComplete="email"
                    required
                    data-testid="forgot-email"
                  />
                </div>
                <button type="submit" disabled={submitting || !email}
                  className="pv-btn-primary w-full flex items-center justify-center gap-2 disabled:opacity-50"
                  data-testid="forgot-submit">
                  {submitting ? 'Enviando…' : 'Enviarme el enlace'}
                  {!submitting && <ArrowRight size={16} strokeWidth={1.75} />}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
